import { storyblokInit } from '@storyblok/react';
import type { AppProps } from 'next/app';

import { RenderedApp, MyAppProps, components } from '@edelman/storyblok-ui';

import { projectComponents } from '../components/custom';
import { appConfig } from '../lib';
import { themeData } from '../styles/configloader';
import '../styles/themeloader.css';

storyblokInit({
  accessToken: process.env.STORYBLOK_TOKEN,
  components: { ...components, ...projectComponents },
});

const App = ({ Component, pageProps }: AppProps<MyAppProps>) => {
  return RenderedApp({ Component, pageProps, appConfig, themeData });
};

export default App;
